import axios from "axios";

/**
 * Creates a new benefit redemption for the provided ally.
 * @param {string|number} allyId
 * @param {Record<string, unknown>} payload
 * @returns {Promise<any>}
 */
export const createRedemption = async (allyId, payload) => {
  if (!allyId) {
    throw new Error("createRedemption requires a valid allyId");
  }

  const { data } = await axios.post(`/api/aliados/${allyId}/benefits`, payload);
  return data;
};

export default {
  createRedemption,
};
